import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config/config'; // 👈 asegurarte de importar esto
import './Confirmacion.css';

const Confirmacion = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [reserva, setReserva] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getQueryParam = (key) => {
    return new URLSearchParams(location.search).get(key);
  };

  const formatearFecha = (fechaISO) => {
    const fecha = new Date(fechaISO);
    return fecha.toLocaleDateString('es-ES', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  const formatearHora = (hora) => {
    const [h, m] = hora.split(':');
    return `${h}:${m}`;
  };

  useEffect(() => {
    const sessionId = getQueryParam('session_id');

    if (!sessionId) {
      setError('No se encontró el ID de sesión.');
      setLoading(false);
      return;
    }

    fetch(`${API_BASE_URL}/stripe/consulta-sesion?session_id=${sessionId}`)
      .then((res) => {
        if (!res.ok) throw new Error('No se pudo obtener la sesión');
        return res.json();
      })
      .then((data) => {
        setReserva(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Error al recuperar la reserva.');
        setLoading(false);
      });
  }, [location.search]);

  if (loading) return <p className="loading">⏳ Cargando información de la reserva...</p>;
  if (error) return <p className="error">❌ {error}</p>;

  return (
    <div className="confirmacion-container compact">
      <div className="confirmacion-card">
        <h1 className="titulo">✅ ¡Reserva realizada correctamente!</h1>
        <p className="subtitulo">Gracias por reservar con nosotros. Aquí tienes los detalles:</p>

        <div className="resumen">
          <p><strong>Pista:</strong> {reserva.pista}</p>
          <p><strong>Día:</strong> {formatearFecha(reserva.dia)}</p>
          <p><strong>Horario:</strong> {
            (() => {
              const ordenadas = [...reserva.horas].sort();
              const inicio = formatearHora(ordenadas[0]);
              const [h, m] = ordenadas[ordenadas.length - 1].split(':');
              const finDate = new Date();
              finDate.setHours(Number(h));
              finDate.setMinutes(Number(m) + 30);
              const fin = finDate.toLocaleTimeString('es-ES', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              });
              return `${inicio} - ${fin}`;
            })()
          }</p>
        </div>

        <button className="boton" onClick={() => navigate('/')}>
          Volver al menú principal
        </button>
      </div>
    </div>
  );
};

export default Confirmacion;
